import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getLatestHappeningsData} from '../utils/endpoints'
import { Container, Row } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import EventsCard from './components/eventsCard';
import { Helmet } from 'react-helmet';

const Events = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [latestHappeningsData, setLatestHappeningsData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const latestHappeningsData = await getLatestHappeningsData(id);
            setLatestHappeningsData(latestHappeningsData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      const faQSlice = faqs;

      const latestData = latestHappeningsData?.filter(item => item?.acf?.eventtype === 'latest');
      const celebrityData = latestHappeningsData?.filter(item => item?.acf?.eventtype === 'celebrity');
      const lokarpanData = latestHappeningsData?.filter(item => item?.acf?.eventtype === 'lokarpan');
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Places to visit in nathdwara |  nathdwara shiva statue timings</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>Events at Statue of Belief</li>
            </ul>
            <h1>Events at Statue of Belief</h1>
          </Container>
        </section>
        <Container className='pt-5'>
          <section className='mb-5 border-bottom'>
            <h2 className='blog-heading'>Latest Events</h2>
            <Row>
            <EventsCard compData={latestData}/>
            </Row>
          </section>
          <section className='mb-5 border-bottom'>
            <h2 className='blog-heading'>Celebrity Event</h2>
            <Row>
            <EventsCard compData={celebrityData}/>
            </Row>
          </section>
          <section>
            <h2 className='blog-heading'>Lokarpan Mahotsav</h2>
            <Row>
            <EventsCard compData={lokarpanData}/>
            <>{console.log(lokarpanData, "lokarpanData")}</>
            </Row>
          </section>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default Events;